import AppThemeShell from "../shared/AppThemeShell";
import { useDocumentTitle } from "../shared/useDocumentTitle";
import Rapportkatalog from "./Rapportkatalog";

function App() {
    useDocumentTitle("Rapportkatalog - Kunnskapshuset Enova");

    return (
        <AppThemeShell color="sjoblaa">
            <Rapportkatalog />
        </AppThemeShell>
    );
}

export default App;
